import React from 'react';
import { Divider } from '@mui/material';
import styled from 'styled-components';
import Form from './Form';

const ContactMe = () => {
  return (
    <ContactMeContainer name='contactMe'>
      <Divider
        style={{
          color: '#2c3e50',
          fontWeight: '100',
          fontSize: '32px',
          width: '90%',
        }}
      >
        Contact Me
      </Divider>

      <CardContainer>
        <ContactCardsContainer>
          <a href='mailto:speechwithbrandy@gmail.com'>
            <ContactCard>
              <ContactIcon>✉️</ContactIcon>
              <ContactTitle>Email</ContactTitle>
              <ContactInfo>speechwithbrandy@gmail.com</ContactInfo>
            </ContactCard>
          </a>
        </ContactCardsContainer>

        <ContactCardsContainer>
          <ContactCard>
            <ContactIcon style={{ fontSize: '1.8rem', marginTop: '10px' }}>
              📞
            </ContactIcon>
            <ContactTitle>Phone</ContactTitle>
            <ContactInfo>(929)-548-3290</ContactInfo>
          </ContactCard>
        </ContactCardsContainer>

        <ContactCardsContainer>
          <ContactCard>
            <ContactIcon style={{ fontSize: '1.8rem', marginTop: '10px' }}>
              📍
            </ContactIcon>
            <ContactTitle>Location</ContactTitle>
            <ContactInfo>Metro Atlanta, GA</ContactInfo>
          </ContactCard>
        </ContactCardsContainer>
      </CardContainer>

      <SendMessageTitle>Send a Message</SendMessageTitle>
      <Form />
    </ContactMeContainer>
  );
};

export default ContactMe;

const CardContainer = styled.div`
  display: flex;
  gap: 30px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
    max-width: 400px;
    margin: 0 auto;

    /* Make the third card span both columns and center it */
    > :nth-child(3) {
      grid-column: 1 / -1;
      justify-self: center;
    }
  }
`;

const ContactMeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;

  h1 {
    font-weight: 100;
    text-align: center;
    @media (min-width: 375px) and (max-width: 768px) {
      padding: 2rem;
    }
  }
`;

const ContactCardsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
  flex-wrap: wrap;

  a {
    text-decoration: none;
    color: inherit;
  }

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const ContactCard = styled.div`
  background: #e6f8fb;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 220px;
  height: 120px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    width: 140px;
    height: 100px;
    padding: 8px;
    font-size: 12px;
  }

  @media (max-width: 480px) {
    width: 120px;
    height: 90px;
    padding: 6px;
  }
`;

const ContactIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #2c3e50;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 0.5rem;
  }

  @media (max-width: 480px) {
    font-size: 1.5rem;
    margin-bottom: 0.3rem;
  }
`;

const ContactTitle = styled.h3`
  font-family: 'Georgia', serif;
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  margin-top: 0;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 0.3rem;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 0.2rem;
  }
`;

const ContactInfo = styled.p`
  font-size: 0.9rem;
  color: #5d6d7e;
  margin: 0;
  line-height: 1.4;
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    line-height: 1.2;
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
    line-height: 1.1;
  }
`;

const SendMessageTitle = styled.div`
  font-size: 28px;
  text-align: center;
  margin-top: 40px;
`;
